<template>
  <div>
    <h1>
      Documents
      <span v-if="documents && documents.length > 0"
        >&#160;({{ documents.length }})</span
      >
    </h1>
    <v-data-table
      :headers="headers"
      :loading="$apollo.queries.documents.loading"
      :items="documents"
      hide-actions
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr :class="props.item.archived ? 'documentItemArchived' : ''">
          <td>
            <v-btn
              :to="{ name: 'documentEdit', params: { id: props.item.id } }"
              small
              >{{ props.item.id }}</v-btn
            >
            <a
              @click="downloadFo(props.item)"
              v-if="$keycloak.hasRealmRole('documentadmin')"
              >fo</a
            >
          </td>
          <td>
            <FileGql v-if="props.item.file" :file="props.item.file" />
            <span v-if="!props.item.file">{{ props.item.fileid }}</span>
          </td>
          <td>
            <router-link
              :to="{
                name: 'template',
                params: { id: props.item.templateRevision.snippet.template.id }
              }"
              v-if="props.item.templateRevision.snippet.template"
            >
              <span>{{
                props.item.templateRevision.snippet.template.code
              }}</span> </router-link
            >&#160;
            <router-link
              :to="{
                name: 'revision',
                params: { id: props.item.templateRevision.id }
              }"
              style="font-size: 0.8em"
              v-if="$keycloak.hasRealmRole('documentadmin')"
              >{{ props.item.templateRevision.id }}</router-link
            >
          </td>
          <td>
            <EntityZ
              v-if="props.item.user"
              :entity="props.item.user"
              format="system"
            />
            <span v-if="!props.item.user">{{ props.item.userid }}</span>
          </td>
          <td>{{ props.item.timestamp | formatTime }}</td>
          <td>
            <v-btn @click="download(props.item)" small>
              <v-icon>picture_as_pdf</v-icon>View
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import DOCUMENTS from "@/graphql/document/Documents";
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
export default {
  name: "Documents",
  metaInfo() {
    return {
      title: "Documents",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    documents: {
      query: DOCUMENTS,
      variables() {
        return {
          date: this.computedDate
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    FileGql
  },
  computed: {
    computedDate() {
      return this.$route.query.date
        ? this.$route.query.date.substring(0, 4) +
            "-" +
            this.$route.query.date.substring(4, 6) +
            "-" +
            this.$route.query.date.substring(6, 8)
        : new Date().toISOString().substr(0, 10);
    }
  },
  data() {
    return {
      headers: [
        {
          text: "id",
          value: "id"
        },
        {
          text: "reference",
          value: "file.fileId"
        },
        {
          text: "template",
          value: "template.code"
        },
        {
          text: "user",
          value: "user.name"
        },
        {
          text: "time",
          value: "timestamp"
        },
        {
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    downloadFo(document) {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/document/documents/${document.id}/fo`,
        "_blank"
      );
    },
    download(document) {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/document/documents/${document.id}/false`,
        "_blank"
      );
    }
  }
};
</script>
